jQuery(function(){

	// Handle table tool tip actions

	jQuery('body').on('click mouseover', '.tooltip__link', function(e){
		e.preventDefault();
		var $this = jQuery(this);
		var $tooltip = $this.closest(".tooltip__identifier").siblings('.tooltip__container');

		tooltip_copy_height();

        jQuery('.tooltip__container--open').each(function(ndex, element){
            if($this != jQuery(element)) {
                jQuery(element).removeClass('tooltip__container--open');
            }
        });

		if(!$tooltip.hasClass('tooltip__container--open')) {
			$tooltip.addClass('tooltip__container--open');
			$tooltip.attr('tabindex', '-1');
			$tooltip.focus();
		} else {
			if(e.type != 'mouseover')
				$tooltip.removeClass('tooltip__container--open');
		}

		return false;
	});

	// Close Tooltip
	jQuery(document).on('click', function(e){
		var $target = jQuery(e.target);
		if(!$target.hasClass('tooltip__container--open')) {
			//e.preventDefault();
			jQuery('.tooltip__container--open').removeClass('tooltip__container--open');
		}
	});

	if (jQuery(".tooltip__link--close")){
		jQuery(".tooltip__link--close").on('click', function(e){
			e.preventDefault();
		});

		jQuery(".tooltip__link--close").focusout(function(){
			var tooltipModal = jQuery(this).parent().parent();
			if (tooltipModal.hasClass("tooltip__container--open")) {
				tooltipModal.removeClass("tooltip__container--open");
			}
		});
	}

	jQuery('body').on('click', '.tooltip__container', function () {
         jQuery('.tooltip__container--open').removeClass('tooltip__container--open');
	});

});


// Tooltip height on window resize
jQuery(window).on('resize', function(){
      tooltip_copy_height();
});

// Tooltip height Calculation
function tooltip_copy_height(){

	jQuery(".tooltip__identifier").each(function(index, element){
		var $this = jQuery(this);
		var $tooltip_identifier = $this.outerHeight() + 10;
		//height styling
		var $tooltip_copy_height = $this.siblings(".tooltip__container").find(".tooltip__copy").outerHeight() + 21 + 40 - 6;
		$this.siblings(".tooltip__container").innerHeight($tooltip_copy_height);
		//position top styling
		$this.siblings(".tooltip__container").css("top", $tooltip_identifier + "px");
	});
}
